/**
 * Cross-runtime route contract for workspace invite delivery and acceptance.
 * The email producer and browser router both consume this value so a path
 * change cannot silently create a dead link.
 */
export const INVITE_ACCEPTANCE_ROUTE_PATTERN = '/join/:token' as const;

export function buildInviteAcceptancePath(inviteToken: string): string {
  return INVITE_ACCEPTANCE_ROUTE_PATTERN.replace(':token', encodeURIComponent(inviteToken));
}
